import { useAtomValue } from 'jotai';
import { useCallback, useEffect } from 'react';

import { MeasureBundleObject, shouldPromptForCSSRS } from '@grow-therapy-team/seedling-components';

import { toast } from '../../toasts';
import { roomAtom } from '../../video-sdk';
import { useOpenClientInformationCallback } from '../client-information/useClientInformationDrawerCallbacks';
import { ProviderDrawerState } from '../state';
import { CSSRSPromptToast } from './CSSRSPromptToast';

const TOAST_KEY = 'cssrs-prompt';

export function useCSSRSPromptToastCallback() {
  const room = useAtomValue(roomAtom);
  const openClientInformation = useOpenClientInformationCallback();

  useEffect(
    function clearToastOnRoomDisconnect() {
      if (!room) {
        toast.close(TOAST_KEY);
      }
    },
    [room],
  );

  return useCallback(
    (
      {
        visitorName,
        visitorUuid,
        patientShortId,
      }: { visitorName: string; visitorUuid: string; patientShortId: string },
      patientChart?: {
        preferredShortName?: string | null;
        measureBundles?: MeasureBundleObject[];
      } | null,
    ) => {
      if (!patientChart) {
        return;
      }

      if (!patientChart.measureBundles || !shouldPromptForCSSRS(patientChart?.measureBundles ?? [])) {
        return;
      }

      toast.enqueue(
        ({ closeToast, ...ariaProps }) => {
          return (
            <CSSRSPromptToast
              {...ariaProps}
              patientName={patientChart.preferredShortName || visitorName}
              onAdministerCSSRS={() => {
                openClientInformation({ visitorUuid, patientShortId }, ProviderDrawerState.CSSRS_FORM);
                closeToast();
              }}
            />
          );
        },
        { key: TOAST_KEY, timeout: Infinity },
      );
    },
    [openClientInformation],
  );
}
